<script>
    export default {
        props: {
            autoFocus: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            // focus element after transition (if any) has completed, and if this.autoFocus == true
            if (this.autoFocus) {
                let el = this.$refs[this.name];
                let loops = 0;

                waitThen(
                    () => !el.closest("[class*='enter-active']"),
                    () => el.focus()
                );

                function waitThen(until, callback) {
                    if (until() || ++loops > 10) {
                        callback();
                    } else {
                        setTimeout(() => waitThen(until, callback), 100);
                    }
                }
            }
        }
    };
</script>